import { type FetchResult, gql, type TypedDocumentNode, useMutation } from '@apollo/client';
import { useCallback } from 'react';
import type { UpdateOrgSettingsUnitRounding, UpdateOrgSettingsUnitRoundingVariables } from 'types/graphql';
import { ORGANIZATION_SETTINGS_QUERY } from './organizationSettingsQuery';

// Operation name kept for telemetry; the input is the whole `UpdateOrgSettingsInput`, not only unit rounding.
const UPDATE_ORG_SETTINGS_UNIT_ROUNDING: TypedDocumentNode<
  UpdateOrgSettingsUnitRounding,
  UpdateOrgSettingsUnitRoundingVariables
> = gql`
  mutation UpdateOrgSettingsUnitRounding($input: UpdateOrgSettingsInput!) {
    updateOrgSettings(input: $input) {
      id
      unitRounding
    }
  }
`;

/** The organization's settings singleton (`updateOrgSettings`); always refetches the app-wide settings read. */
export function useUpdateOrgSettings() {
  const [mutate, { loading, error }] = useMutation(UPDATE_ORG_SETTINGS_UNIT_ROUNDING, {
    refetchQueries: [{ query: ORGANIZATION_SETTINGS_QUERY }],
  });
  const update = useCallback(
    ({ input }: UpdateOrgSettingsUnitRoundingVariables): Promise<FetchResult<UpdateOrgSettingsUnitRounding>> =>
      mutate({ variables: { input } }),
    [mutate]
  );

  return { update, loading, error };
}
